export function removeTimestampPrefix(filename: string): string {
  const timestampPattern = /^\d{13}-/;
  if (timestampPattern.test(filename)) {
    return filename.substring(filename.indexOf("-") + 1);
  }
  return filename;
}

export function splitFileName(filename: string): { name: string; extension: string } {
  const lastDotIndex = filename.lastIndexOf(".");

  if (lastDotIndex === -1) {
    return {
      name: filename,
      extension: ""
    };
  }

  return {
    name: filename.slice(0, lastDotIndex),
    extension: filename.slice(lastDotIndex + 1)
  };
}
